/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/27/20
 * Time: 11:16 AM
 */
import React,{Component} from 'react';
import '../Profile.scss';
import {Button} from "reactstrap";
import * as commonFunc from "../../../../utils/commonFunc";
import swal from "sweetalert";
import * as constants from "../../../../const/constants";
import md5 from "md5";
import * as validator from "../../../../utils/validator";
import * as studentService from "../../../../services/student";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import {lang, language} from "../../../../const/language";

class App extends Component{
    state = {
        prePassword:'',
        newPassowrd:'',
        rePassord:''
    };
    textOnChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({[name]: value});
    };
    validationHandler = () => {
        let {prePassword,newPassowrd,rePassord} = this.state;
        prePassword === "" ? commonFunc.notifyMessage(language[lang].CurrentPasswordCannotBeEmpty) :
                !validator.passwordRegex.test(newPassowrd) ? commonFunc.notifyMessage(constants.PASSWORD_TEXT) :
                newPassowrd !== rePassord ? commonFunc.notifyMessage(language[lang].PasswordDoNotMatch) :
                    swal({
                        title: constants.ALERT_TEXT,
                        icon: null,
                        closeOnClickOutside: false,
                        buttons: {
                            cancel: language[lang].NoText,
                            dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
                        },
                    }).then((value) => {
                        switch (value) {
                            case "action":
                                this.changePasswordHandler();
                                break;
                            default:
                                break;
                        }
                    });
    };

    changePasswordHandler = async () => {
        let {prePassword,newPassowrd} = this.state;
        const obj = {
            oldPassword: md5(prePassword),
            newPassword: md5(newPassowrd),
        };
        this.props.spinnerHandler({isSpin: true, type: 15});
        await studentService.changePassword(obj)
            .then(response => {
                this.props.spinnerHandler(false);
                commonFunc.notifyMessage(response.message, response.status);

                if (response.success) {
                    this.props.stateHandler(0);
                }
            })
    };
    render() {
        let {prePassword,newPassowrd,rePassord} = this.state;
        return (
            <div className={"profile-middle"}>

                <p className={"p-tag"}>{language[lang].CurrentPassword}</p>
                <input className={"form-control teach-input"} name={"prePassword"} value={prePassword} type={"password"}
                       placeholder={"Enter current password"} onChange={this.textOnChange}/>
                <br/>

                <p className={"p-tag"}>{language[lang].NewPassword}</p>
                <input className={"form-control teach-input"} name={"newPassowrd"} value={newPassowrd} type={"password"}
                       placeholder={"Enter new password"} onChange={this.textOnChange}/>
                <p className={"p-tag"}>{language[lang].ReEnterNewPassword}</p>
                <input className={"form-control teach-input"} name={"rePassord"} value={rePassord} type={"password"}
                       placeholder={"Enter re type new password"} onChange={this.textOnChange}/>

                <br/>
                <div className={"align-center login-btn-wrapper"}>
                    <Button className="com-btn log-btn auto-width" color="default" onClick={this.validationHandler}>
                        {language[lang].ChangePassword}
                    </Button>
                </div>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data))
});
export default connect(null, mapDispatchToProps)(withRouter(App));
